<template>
  <div class="number-display">
    <div class="row">
      <label class="col-sm-4 control-label">{{ field.label }}</label>
      <div class="col-sm-8">{{ field.value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberDisplay',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// NumberDisplay.vue?5cc27aaa